import {SET_PIN_BEGIN, SET_PIN_FAILURE, SET_PIN_SUCCESS} from "../action/pinAction";

const initialState = {
    pin: null
};

export default function PinReducer(state = initialState, action) {
    switch (action.type) {
        case SET_PIN_BEGIN:
            return {
                ...state,
                loading: true,
                error: null
            };

        case SET_PIN_SUCCESS:
            return {
                ...state,
                loading: false,
                pin: action.payload
            };

        case SET_PIN_FAILURE:
            return {
                ...state,
                loading: false,
                pin: null
            };
        default:
            return state;
    }
}
